import {useEffect} from 'react';
import {Building2, MessageSquareQuote, Shapes, ShieldCheck} from 'lucide-react';
import {JobLoader, type StepDefinition} from '@tinct/web-components';
import {useFunnel} from '@tinct/web-funnel';
import {useStaticAssetsUrl} from '@tinct/core-utils';
import {useBrandExtractionJob} from './hooks/use-brand-extraction-job';

const brandSteps: StepDefinition[] = [
  {title: 'Company Profile', icon: <Building2 />, duration: 20, strategy: 'linear'},
  {title: 'Value & Messaging', icon: <MessageSquareQuote />, duration: 24, strategy: 'linear'},
  {title: 'Visual Identity', icon: <Shapes />, duration: 16, strategy: 'linear'},
  {title: 'Compliance', icon: <ShieldCheck />, duration: 10, strategy: 'exponentialBackoff'},
];

export const Step2Analyzing = () => {
  const {navigateToNextStep} = useFunnel();
  const assetsUrl = useStaticAssetsUrl();

  const {subJobs, allCompleted, gameModal} = useBrandExtractionJob(brandSteps);

  useEffect(() => {
    if (allCompleted) {
      navigateToNextStep();
    }
  }, [allCompleted, navigateToNextStep]);

  return (
    <div
      className="container mx-auto flex w-full flex-col items-center justify-center"
    >
      <div className="flex w-full max-w-xl flex-col gap-8">
        <div className="flex items-end gap-4">
          <div className="flex flex-1 flex-col gap-2">
            <h2 className="font-heading text-3xl font-semibold tracking-tight text-card-foreground">
              Extracting your Identity Assets...
            </h2>
          </div>
          <div className="flex shrink-0 items-end">
            <img
              src={`${assetsUrl}/run-sampling.png`}
              alt=""
              className="w-[100px]"
            />
          </div>
        </div>

        <JobLoader subJobs={subJobs} />
      </div>
      {gameModal}
    </div>
  );
};
